import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderForm_Actor_Update_Mutation = graphql(`
  mutation FolderForm_Actor_Update(
    $actorId: Id!
    $actorableId: Id!
    $list: ActorListEnum!
    $update: ActorUnionInput!
    $versionData: VersionDataInput
  ) {
    updateFolderActor(
      actorId: $actorId
      actorableId: $actorableId
      list: $list
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateFolderActorMutation = () =>
  useGraphQLMutation(FolderForm_Actor_Update_Mutation);
